<template>
	<div class="usp-page applicant">
		<main>
			<b-container>
				<b-row>
					<b-col lg="6">
						<h1>Dein Job findet dich.</h1>
						<h2>
							skilldoo ist deine anonyme Jobmatching Plattform.<br/>
							Aufgrund deiner Wünsche und Skills sucht skilldoo automatisiert nach dem Best-Match.
						</h2>
						<div class="mobile-avatar-button-container">
							<div>
								<Avatar :avatar="avatarCatNotebook"/>
								<div class="anonym">
									<img src="/img/anonym.svg" alt="Anonym"/>
								</div>
								<Button
									text="Passenden Job finden!"
									icon="caret-right"
									href="/kandidat"
								/>
							</div>
						</div>
						<p>
							Das funktioniert ungefähr so wie bei einer Dating-App.<br/>
							Dadurch erhältst du nur Job-Vorschläge, die wirklich gut zu dir passen.
						</p>
						<p class="button-container">
							<Button
								text="Passenden Job finden!"
								icon="caret-right"
								href="/kandidat"
							/>
						</p>
						<p class="button-container">
							<Button
								text="Passende Mitarbeiter finden!"
								secondary
								icon="caret-right"
								href="/mitarbeiterfinden"
							/>
						</p>
						<div class="feature-rows">
							<div class="feature-row left-first">
								<Feature
									icon="homepage-register-once"
									title="Nur 1 Mal bewerben?"
									text="Mit wenigen Klicks deine Wünsche und Skills eintragen.<br/>Und dein Job findet dich."
									color="gold"
								/>
								<Feature
									icon="homepage-chat"
									title="Antwortgarantie?"
									text="Du erhältst regelmäßig Informationen."
									color="yellow"
								/>
							</div>
						</div>
					</b-col>
					<b-col lg="6">
						<div class="avatar-container">
							<Avatar :avatar="avatarCatNotebook"/>
							<div class="anonym">
								<img src="/img/anonym.svg" alt="Anonym"/>
							</div>
						</div>
						<div class="feature-rows right">
							<div class="feature-row first">
								<Feature
									icon="homepage-free"
									title="Kostenlos?"
									text="Für BewerberInnen ist skilldoo kostenlos!"
									color="lime"
								/>
							</div>
							<div class="feature-row second">
								<Feature
									icon="homepage-anonymous"
									title="Anonym?"
									text="Das Best-Match-System ist anonym. Du enscheidest, wer deine Daten bekommt."
									color="turquoise"
								/>
							</div>
							<div class="feature-row third">
								<Feature
									icon="homepage-vita"
									title="Ohne Lebenslauf und Bewerbungsschreiben?"
									text="Du kannst einen Lebenslauf hochladen, musst aber nicht."
									color="purple"
								/>
								<Feature
									icon="homepage-matching"
									title="Best-Match-System?"
									text="skilldoo findet gezielt die passenden Jobs.<br/>Durch Balken wird die Übereinstimmung übersichtlich angezeigt."
									color="lime"
								/>
							</div>
						</div>
					</b-col>
				</b-row>
				<div class="mt-5">
					<h3>So funktioniert's:</h3>
					<div>Schneller und einfacher zum passenden Job.</div>
					<HowItWorks type="application" class="mt-4"/>
					<ApplicantBenefits class="mt-5"/>
					<div class="mt-4 text-center">
						<Button icon="caret-right" text="Passenden Job finden!" href="/kandidat"/>
					</div>
					<div class="d-none d-md-block mt-4 text-center">
						<Button secondary icon="caret-right" text="Passende Mitarbeiter finden!" href="/mitarbeiterfinden"/>
					</div>
				</div>
			</b-container>
		</main>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import Avatar, {CAT_NOTEBOOK} from "@/vue/common/image/Avatar.vue";
import Feature from "@/vue/homepage/Feature.vue";
import HowItWorks from "@/vue/info/HowItWorks.vue";
import ApplicantBenefits from "@/vue/info/ApplicantBenefits.vue";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

export default {

	components: {
		ApplicantBenefits,
		HowItWorks,
		Feature,
		Avatar,
		Button,
	},

	mounted ()
	{
		Event.push(
			new EventData()
				.setEvent(Event.PAGE_VISIT)
				.setAction('Jobfinden = Kandidaten-Startseite')
		);
	},

	computed: {
		avatarCatNotebook ()
		{
			return CAT_NOTEBOOK;
		}
	}
}
</script>
